function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { basePropTypes, handleProps, StyledButton } from './utils';
const BaseButton = props => {
  const {
    loading,
    disable,
    children,
    text,
    to,
    href,
    visible,
    download,
    ...rest
  } = props;
  if (visible === false) {
    return null;
  }
  const content = /*#__PURE__*/React.createElement(StyledButton, _extends({
    disabled: disable || loading
  }, handleProps(rest)), children || text, loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 14,
    style: {
      marginLeft: '4px'
    }
  }));
  if (to) {
    return /*#__PURE__*/React.createElement(Link, {
      to: to
    }, content);
  }
  if (download && href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      download: download
    }, content);
  }
  if (href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href
    }, content);
  }
  return content;
};
BaseButton.propTypes = basePropTypes;
export default BaseButton;